/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Faq_1_AnswerInputs */

const en_svc_rag_faq_1_answer = /** @type {(inputs: Svc_Rag_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrieval-augmented generation. Before answering, the system searches your documents for the relevant passages and gives them to the language model, which writes the answer from them and cites them. It is how an AI assistant can answer about your business without being retrained.`)
};

const lv_svc_rag_faq_1_answer = /** @type {(inputs: Svc_Rag_Faq_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrieval-augmented generation jeb izguvē balstīta ģenerēšana. Pirms atbildes sistēma Jūsu dokumentos atrod atbilstošos fragmentus un nodod tos valodas modelim, kas no tiem uzraksta atbildi un norāda avotus. Tā AI asistents var atbildēt par Jūsu uzņēmumu bez modeļa pārapmācības.`)
};

/**
* | output |
* | --- |
* | "Retrieval-augmented generation. Before answering, the system searches your documents for the relevant passages and gives them to the language model, which wr..." |
*
* @param {Svc_Rag_Faq_1_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_faq_1_answer = /** @type {((inputs?: Svc_Rag_Faq_1_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Faq_1_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_faq_1_answer(inputs)
	return en_svc_rag_faq_1_answer(inputs)
});